import { render, staticRenderFns } from "./estadisticas-inicio-venta-mercadolibre.vue?vue&type=template&id=46b60e34&scoped=true&"
import script from "./estadisticas-inicio-venta-mercadolibre.vue?vue&type=script&lang=ts&"
export * from "./estadisticas-inicio-venta-mercadolibre.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b60e34",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow,VSpacer})
